import { render, staticRenderFns } from "./mode12.vue?vue&type=template&id=4d8c4123&scoped=true"
import script from "./mode12.vue?vue&type=script&lang=js"
export * from "./mode12.vue?vue&type=script&lang=js"
import style0 from "./mode12.vue?vue&type=style&index=0&id=4d8c4123&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8c4123",
  null
  
)

export default component.exports